import {Serializers} from '../../interfaces/serializer';
import {DataSetMetric} from '../../interfaces/metrics';
import {MetricComponentObjects} from '../../classes/metric-component-object';

export const DATASET_METRICS_STATE_NAME = 'dataSetMetrics';

export interface DataSetMetricsState {
  serialized: {
    all: Serializers<DataSetMetric>;
    source: Serializers<DataSetMetric>;
    normalized: Serializers<DataSetMetric>;
    calculated: Serializers<DataSetMetric>;
  };
  componentObjects: {
    all: MetricComponentObjects;
    source: MetricComponentObjects;
    normalized: MetricComponentObjects;
    calculated: MetricComponentObjects;
  };
  loading: boolean;
  loaded: boolean;
}
